export default {
	Slide: 'Puzzle',
	Puzzle: 'Puzzle',
	'The puzzle is open!': 'Il puzzle è aperto!',
	'Congratulations!': 'Congratulazioni!',
	'You get it': 'Hai ottenuto',
	'You get the task done': 'Hai completato il compito',

	'Show all blocked': 'Mostra tutti gli utenti bloccati',

	Author: 'Autore',
	'Reset filters': 'Reset filtri',

	Blocked: 'Bloccato',
	Unlocked: 'Sbloccato',

	Change: 'Modifica',

	'The student is blocked': 'Lo studente è bloccato',
	'The student is blocked with a new price':
		'Lo studente è bloccato con una nuova tariffa',
	'To unlock this student, go to the "Restore" section':
		'Per sbloccare questo studente, vai alla sezione "Ripristina"',

	'Before blocking, you can change the price for the student':
		'Prima di bloccare, puoi modificare la tariffa per lo studente',

	'Block student': 'Blocca studente',

	'First month cost': 'Prezzo per il primo mese',

	'WARNING! After re-saving the task, the students who completed this task will have the puzzle closed and will have to do it again.':
		'ATTENZIONE! Dopo aver salvato nuovamente il compito, gli studenti che lo hanno completato vedranno il puzzle chiuso e dovranno rifarlo.',

	"You cannot do homework in the student's platform":
		'Non puoi fare i compiti nella piattaforma dello studente',

	'Restore the student ?': 'Ripristinare lo studente?',
	'Restore the teacher ?': 'Ripristinare l’insegnante?',
	'Restore the franchise ?': 'Ripristinare il franchise?',

	'Transition to 50': 'Passaggio con 50',
	'Transition to 100': 'Passaggio con 100',

	fifty: 'Passaggio con 50',
	hundred: 'Passaggio con 100',

	Faces: 'Faccine',

	Heroes: 'Eroi',
	Clothes: 'Abiti',
	Backgrounds: 'Sfondi',
	Souvenirs: 'Souvenir',

	'Coming soon': 'Prossimamente',

	'Wow! Congratulations, you have successfully purchased this product.':
		'Wow! Congratulazioni, hai acquistato con successo questo prodotto.',
	'You can view all your purchases in the "Purchased" section':
		'Puoi visualizzare tutti i tuoi acquisti nella sezione "Acquisti"',

	'Your savings': 'I tuoi risparmi',
	'You can spend them on something interesting!':
		'Puoi usarli per qualcosa di interessante!',

	'A student with this email address already exists':
		'Esiste già uno studente con questo indirizzo email',

	'User with such email already exists':
		'Esiste già uno studente con questo indirizzo email',
	'Year of birth': 'Anno di nascita',
	Registration: 'Registrazione',
	'Surname of parents': 'Cognome dei genitori',
	School: 'Scuola',
	'Field is required': 'Campo obbligatorio',
	'Select age': 'Seleziona età',
	'No such teacher for this year':
		"Quest'anno non c'è nessun insegnante del genere",
	'User with such phone number already exists':
		'Esiste già un utente con questo numero di telefono',
	'You are successfully registered': 'Registrazione completata con successo',
	'Max length 20 chars': 'Lunghezza massima: 20 caratteri',
	'Після реєстрації вам надійде лист з логіном і паролем':
		'Dopo la registrazione riceverai un’email con login e password',

	'INTERNATIONAL SCHOOL': 'SCUOLA INTERNAZIONALE',
	'Mental Arithmetic': 'Aritmetica Mentale',
	'For children aged 5-14.': 'Per bambini dai 5 ai 14 anni.',
	'Sign up for a trial lesson': 'Iscriviti a una lezione di prova',
	'Parents name': 'Nome del genitore',
	'Childs age': 'Età del bambino',
	Country: 'Paese',
	'Sign up': 'Iscriviti',

	'Open offer agreement': 'Contratto di offerta pubblica',
	'Participate in online Indigo Olympiad':
		'Partecipa all’Olimpiade online di Indigo!',
	Participate: 'Partecipa',
	export: 'Esporta',

	wrong: 'Sbagliato',
	right: 'Corretto',
	match: {
		addition: 'Calcolo',
		multiply: 'Moltiplicazione',
		divide: 'Divisione',
		abacus_random: 'Abaco casuale',
		anzan: 'Anzan',
		negative: 'Numeri negativi',
		column: 'Colonne',
	},
	timeIsOver: 'Il tempo è scaduto',
	timer: 'Timer',
	'Back to Lessons': 'Torna alle lezioni',
	'Create Lesson': 'Crea lezione',
	Assign: 'Assegna',
	Home: 'Home',
	'To cabinet': 'Vai al tuo account',
	'Create a homework': 'Crea i compiti',
	January: 'Gennaio',
	February: 'Febbraio',
	March: 'Marzo',
	April: 'Aprile',
	May: 'Maggio',
	June: 'Giugno',
	July: 'Luglio',
	August: 'Agosto',
	'Group nickname': 'Nome del gruppo',
	September: 'Settembre',
	October: 'Ottobre',
	November: 'Novembre',
	December: 'Dicembre',
	Overall: 'Totale',
	Active: 'Attivi',
	'Contract number': 'Numero di contratto',
	'For parents': 'Per i genitori',
	'Choose lessons': 'Scegli le lezioni',
	Save: 'Salva',
	'Students active': 'Studenti attivi',
	Close: 'Chiudi',
	'Change birthday': 'Modifica data di nascita',
	Sent: 'Inviato',
	'Choose date': 'Scegli data',
	'Include students': 'Includi studenti',
	'Add service': 'Aggiungi servizio',
	'Create folder': 'Crea cartella',
	Answer: 'Risposta',
	Price: 'Tariffa',
	'Date of creating': 'Data di creazione',
	Month: 'Mese',
	unpaid: 'Non pagato',
	paid: 'Pagato',
	'Excluded students': 'Studenti esclusi',
	'Selected groups': 'Gruppi selezionati',
	Monday: 'Lunedì',
	Tuesday: 'Martedì',
	Wensday: 'Mercoledì',
	Thusday: 'Giovedì',
	Friday: 'Venerdì',
	Saturday: 'Sabato',
	Sunday: 'Domenica',
	Mo: 'Lu',
	Tu: 'Ma',
	We: 'Me',
	Th: 'Gi',
	Fr: 'Ve',
	Sa: 'Sa',
	Su: 'Do',
	End: 'Fine',
	'Add discount': 'Aggiungi sconto',
	Edit: 'Modifica',
	'Parent found': 'Genitore trovato',
	'Changes saved': 'Modifiche salvate',
	'The passwords of the parent and the student should not coincide':
		'Le password del genitore e dello studente non devono coincidere',
	'Your region`s price is set to':
		'Il prezzo per la tua regione è impostato su ',
	'and the holder`s reward is': 'e il compenso del titolare è',
	'regardless of the set price': 'indipendentemente dal prezzo impostato',
	'The given password is not unique for this email':
		'La password inserita errata',
	'Enter a valid email address.': 'Inserisci un indirizzo email valido.',
	'The phone number entered is not valid':
		'Il numero di telefono inserito non è valido',
	Holiday: 'Festività',
	'Working days': 'Giorni lavorativi',
	Street: 'Via',
	'Location name': 'Nome della sede',
	District: 'Quartiere',
	'Mental arithmetic is an oral account technique that rapidly develops the intellectual ability and intelligence of a child between 5 and 14 years of age. The training process takes place on special Japanese accountants Abaсus (Soroban). Mental arithmetic trains simultaneously the left and right hemispheres of the brain, improving visual memory, concentration of attention, creative orientation, imaginative thinking of children and their tendency to fast reading.':
		"L'aritmetica mentale è una tecnica di calcolo orale che sviluppa rapidamente le capacità intellettive e l’intelligenza dei bambini tra i 5 e i 14 anni. L’apprendimento avviene con l’abaco giapponese (Soroban). L’aritmetica mentale allena simultaneamente gli emisferi sinistro e destro del cervello, migliorando la memoria visiva, la concentrazione, la creatività, il pensiero dell'immaginazione e la capacità di lettura veloce dei bambini.",
	'Field required': 'Campo obbligatorio',
	'Type of legal activity': 'Tipo di attività legale',
	'Legal address': 'Indirizzo legale',
	'Registration number': 'Numero di registrazione',
	'Add Group': 'Aggiungi gruppo',
	'Add Student': 'Aggiungi studente',
	Add: 'Aggiungi',
	'Add file': 'Aggiungi file',
	Signin: 'Accedi',
	'Bonus days': 'Giorni bonus',
	'Bonus weeks': 'Settimane bonus',
	'Are you sure you want to delete?': 'Sei sicuro di voler eliminare?',
	Delete: 'Elimina',
	Days: 'Giorni',
	Confirm: 'Conferma',
	Cancel: 'Annulla',
	Week: 'Settimana',
	Weeks: 'Settimane',
	'Group age name': 'Nome del gruppo per età',
	'Set bonus days': 'Imposta giorni bonus',
	'Default language': 'Lingua predefinita',
	'With english': 'Con inglese',
	'Without english': 'Senza inglese',
	'Paid status': 'Stato del pagamento',
	'Not paid': 'Non pagato',
	Turnover: 'Fatturato',
	Block: 'Blocca',
	'On holidays': 'In vacanza',
	Language: 'Lingua',
	Discounts: 'Sconti',
	Message: 'Notifiche',
	Subject: 'Argomento',
	Homework: 'Compiti',
	'Homework ': 'Esercizi',
	'Homework on': 'Compiti per il',
	'You need to complete the exercises': 'Devi completare gli esercizi',
	// второй ключ Homework в исходнике перетирает первый, если нужен список – переименуй:
	HomeworkList: 'Compiti',
	'Invoice for': 'Fattura per',
	"PJSC CB 'PRIVATBANK' in Kyiv": "PJSC CB 'PRIVATBANK' Kyiv",
	Account: 'Conto',
	Supplier: 'Fornitore',
	Buyer: 'Acquirente',
	'Bank code': 'Codice bancario',
	'Type phone number or email': 'Inserisci numero di telefono o email',
	'Type password': 'Inserisci password',
	'Forgot password': 'Hai dimenticato la password?',
	'Type your email': 'Inserisci la tua email',
	Send: 'Invia',
	'Email sent': 'Email inviata',
	'If you are signed up for the project you will receive email with the next instructions to get back access your account':
		'Se esiste un account con questa email, riceverai un messaggio con le istruzioni per il recupero dell’accesso',
	'Back to the sign in': 'Torna al login',
	'Password or login is not correct': 'Email o password errata',
	'Password recovery': 'Recupero password',
	'Type your new password here': 'Inserisci la nuova password',
	'Set new password': 'Imposta nuova password',
	'Learn more': 'Scopri di più',
	'About Us': 'Chi siamo',
	Company: 'Azienda',
	Jobs: 'Lavora con noi',
	Press: 'Stampa',
	'Terms of Use': 'Termini di utilizzo',
	'Privacy Policy': 'Informativa sulla privacy',
	'Need help?': 'Hai bisogno di aiuto?',
	'Contact us': 'Contattaci',
	'Become franchise': 'Diventa franchisee',
	'Select language': 'Seleziona lingua',
	English: 'Inglese',
	Russian: 'Russo',
	Azerbaijani: 'Azerbaigiano',
	Ukrainian: 'Ucraino',
	Polish: 'Polacco',
	Management: 'Gestione',
	'Master Franchise': 'Master Franchise',
	Franchise: 'Franchising',
	Teachers: 'Insegnanti',
	Groups: 'Gruppi',
	Students: 'Studenti',
	Student: 'Studente',
	Parents: 'Genitori',
	Profile: 'Profilo',
	'My profile': 'Il mio profilo',
	Finance: 'Finanze',
	Reports: 'Rapporti',
	Report: 'Rapporto',
	Upload: 'Carica',
	List: 'Elenco',
	Payments: 'Pagamenti',
	Documents: 'Documenti',
	Lessons: 'Lezioni',
	Materials: 'Materiali',
	Shop: 'Negozio',
	Statistics: 'Statistiche',
	Settings: 'Impostazioni',
	Pages: 'Pagine',
	Logout: 'Esci',
	Dashboard: 'Profilo personale',
	'Access denied': 'Accesso negato',
	Create: 'Crea',
	New: 'Nuovo',
	Download: 'Scarica',
	Status: 'Stato',
	'Payment Date': 'Data di pagamento',
	'Payment Amount': 'Importo del pagamento',
	'Start time': 'Ora di inizio',
	'Group age': 'Fascia d’età',
	Junior: 'Piccoli',
	Average: 'Medi',
	Class: 'Classe',
	Older: 'Grandi',
	Region: 'Regione',
	Group: 'Gruppo',
	Person: 'Persona',
	Finances: 'Finanze',
	Actions: 'Azioni',
	'Send invoice': 'Invia fattura',
	'Download invoice': 'Scarica fattura',
	'Send email': 'Invia email',
	'Create Student': 'Crea studente',
	'The beginning of holidays': 'Inizio vacanze',
	'Start of study': 'Inizio lezioni',
	'Group name': 'Nome del gruppo',
	'Group address': 'Indirizzo del gruppo',
	'Group teacher': 'Insegnante del gruppo',
	'Group students': 'Studenti del gruppo',
	'Group statistics': 'Statistiche del gruppo',
	Search: 'Cerca',
	'General information': 'Informazioni generali',
	'Phone number': 'Numero di telefono',
	'First name': 'Nome',
	Surname: 'Отчество',
	'Last name': 'Cognome',
	'Date of birth': 'Data di nascita',
	Password: 'Password',
	'Additional information': 'Informazioni aggiuntive',
	'Id code': 'Codice ID',
	Passport: 'Passaporto',
	'Without email newsletter': 'Senza newsletter via email',
	'With email newsletter': 'Con newsletter via email',
	'Financial information': 'Informazioni finanziarie',
	Royalty: 'Royalty',
	'PR contribution': 'Contributo PR',
	Currency: 'Valuta',
	Comment: 'Commento',
	Paid: 'Pagato',
	Invoices: 'Fatture',
	Bills: 'Conti',
	Acts: 'Atti',
	Scan: 'Scansione',
	Level: 'Livello',
	'Action with numbers': 'Azione con i numeri',
	'Action with number': 'Azione con numero',
	'Number of expressions': 'Numero di espressioni',
	'Number of expression': 'Numero di espressione',
	'Imaginary abacus': 'Abaco immaginario',
	'Period report': 'Periodo di riferimento',
	City: 'Città',
	'Full name franchise': 'Nome completo del franchisee',
	'Сost of education': 'Costo totale',
	'Turnover franchise': 'Fatturato del franchise',
	'Discount sum': 'Totale sconti',
	Proprietor: 'Royalty',
	'Additional products and services': 'Prodotti e servizi aggiuntivi',
	'Full name student': 'Nome completo dello studente',
	'Period of study': 'Periodo di studio',
	'Bonus-days': 'Giorni bonus',
	'Amount of days': 'Numero di giorni',
	'Total days': 'Giorni totali',
	'Language of instruction': 'Lingua d’insegnamento',
	Teacher: 'Insegnante',
	Discount: 'Sconto',
	Remuneration: 'Compenso',
	Goods: 'Prodotti',
	'Date of creation': 'Data di creazione',
	'Date of payment': 'Data di pagamento',
	'Goods (works, services)': 'Prodotti (lavori, servizi)',
	Quantity: 'Quantità',
	Units: 'Unità',
	Amount: 'Importo',
	Sum: 'Totale',
	'Sum Sub': 'Subtotale',
	Financial: 'Finanziario',
	Additional: 'Aggiuntivo',
	General: 'Generale',
	Total: 'Totale',
	Save: 'Salva',
	'Including with': 'Incluso con',
	'Training materials': 'Materiali di formazione',
	'Learning contract': 'Contratto di apprendimento',
	Games: 'Giochi',
	'NUMBER OF 11 TO 120': 'NUMERI DA 11 A 120',
	Complexity: 'Complessità',
	Start: 'Inizio',
	'Speedy numbers': 'Calcoli',
	Anzan: 'Anzan',
	'Abacus is random': 'Abaco casuale',
	Multiplication: 'Moltiplicazione',
	Division: 'Divisione',
	Abacus: 'Abaco',

	'Multiplying by 20': 'Moltiplicazione fino a 20',
	Squared: 'Elevamento al quadrato',
	'Division to 20': 'Divisione fino a 20',
	Speed: 'Velocità',
	Repeat: 'Riprova',
	'Game type': 'Tipo di gioco',
	'Digit type': 'Tipo di numero',
	Digit: 'Numero',
	Time: 'Tempo',
	Oral: 'Abaco immaginario',
	Second: 'Secondi',
	'Calculation method': 'Metodo di calcolo',
	'Only negative numbers starting with 99,999,9999 etc., depending on the complexity of the expression: -9, -2, -3, -1 ...':
		"Solo numeri negativi a partire da 99,999,9999 ecc., a seconda della complessità dell'esempio: -9, -2, -3, -1...",
	'Only subtraction': 'Solo sottrazione',
	'Only positive numbers starting with 0. Expression: +1, +4, +6, +9, +5 ...':
		'Solo numeri positivi a partire da 0. Esempio: +1, +4, +6, +9, +5 ...',
	'Only add': 'Solo addizione',
	'Numbers fall randomly, starting with 0. Expression :: +3, -5, -1, +9, -2 ...':
		'I numeri appaiono in modo casuale, a partire da 0. Esempio: +3, -5, -1, +9, -2 ...',
	'Random numbers': 'Numeri casuali',
	'CHOOSE COMPLEXITY:': 'SCEGLI LA DIFFICOLTÀ:',
	'AMOUNT OF ACTIONS WITH NUMBER': 'QUANTITÀ DI OPERAZIONI',
	FAMILY: 'FAMIGLIA',
	'BIG FRIENDS': 'GRANDI AMICI',
	'LITTLE FRIENDS': 'PICCOLI AMICI',
	'JUST FRIENDS': 'AMICI',
	'big friends': 'grandi amici',
	'small friends': 'piccoli amici',
	elementary: 'amici',
	family: 'famiglia',
	Sound: 'Suono',
	'Congratulations! You did it! Now you can go to the following exercises':
		'Ottimo lavoro! Sei il migliore!',
	'RIGHT. ANSWER:': 'CORRETTO. RISPOSTA:',
	CORRECT: 'CORRETTO',
	'NOT CORRECT': 'NON CORRETTO',
	'Try again': 'Riprova',
	expression: 'esempio',
	next: 'successivo',
	Next: 'Successivo',
	Previous: 'Precedente',
	Loading: 'Caricamento',
	back: 'indietro',
	Back: 'Indietro',
	ANSWER: 'RISPOSTA',
	Lesson: 'Lezione',
	'History statistics': 'Cronologia delle statistiche',
	Open: 'Apri',
	'Game statistics per day': 'Statistiche giornaliere di gioco',
	'Total played games': 'Giochi totali',
	'Total correct answers': 'Totale risposte corrette',
	'Total played:': 'Totale partite:',
	Feedback: 'Feedback',
	'Leave a review': 'Lascia una recensione',
	'Leave us your feedback or wishes and we will definitely consider them in our work.':
		'Lasciaci i tuoi commenti o suggerimenti e li prenderemo sicuramente in considerazione nel nostro lavoro.',
	'Payment history': 'Storico dei pagamenti',
	'Payment status': 'Stato del pagamento',
	Pay: 'Paga',
	Payer: 'Destinatario',
	'Getting a discount': 'Ottieni uno sconto',
	Training: 'Allenamento',
	Tasks: 'Compiti',

	'Current task': 'Compito attuale',
	'Only task': 'Compito',
	'Next tasks': 'Prossimi compiti',
	'Online abacus': 'Abaco online',
	'Base 50/100': 'Base 50/100',
	multiply_base: 'Base 50/100',
	divided: 'diviso',
	'Do not show this instruction again': 'Non mostrare più questa istruzione',
	'Instructions for homework': 'Istruzioni per i compiti',
	divider: 'divisore',
	'Multiplication table': 'Tabella di moltiplicazione',
	Restore: 'Ripristinare',
	Left: 'Rimasti',
	'Restore Hierarchy': 'Ripristinare la gerarchia',
	total: 'totale',
	active: 'attivi',
	blocked: 'bloccati',
	pageError: {
		403: 'Acceso negato.',
		404: 'Questa pagina non esiste. Riprova.',
		500: 'Il server non risponde. Riprova.',
	},
	error: {
		'Account deactivated': 'Il tuo account è stato disattivato',
	},
	modalNewVersion: {
		text:
			"Stai utilizzando una versione obsoleta del sito.\nL'aggiornamento è già disponibile.",
		btn: 'Aggiorna',
	},
	games: {
		negativeNumbers: 'Numeri negativi',
		pause: 'Pausa',
		resume: 'Riprendi',

		columns: {
			name: 'Colonne',
			users: 'Numero di giocatori',
			user: 'Giocatore',
			userNames: 'Nomi di giocatori',
		},
	},
	'Indigo-dollars': 'Indigo-dollari',
	Balance: 'Saldo',

	modalIndigoDollars: {
		submit: 'Invia',
		cancel: 'Annulla',
		title: 'Indigo-dollari',
		balance: 'Saldo attuale',
		amount: 'Quantità',
		reason: 'Commento',
	},

	modalAddNotification: {
		title: 'Aggiungi notifica',
		submit: 'Invia',
		cancel: 'Annulla',
		empty: 'Nessuna notifica',
	},

	modalTransactionsHistory: {
		title: 'Storico dei pagamenti',
		type: {
			withdraw: 'Addebito',
			deposit: 'Ricarica',
		},
		empty: 'L’elenco dei pagamenti è vuoto',
	},

	modalCopyHomework: {
		title: 'Copia dei compiti',
		label: 'Seleziona la data per copiare i compiti',
		submit: 'Copia',
		cancel: 'Annulla',
	},

	reportsPage: {
		history: {
			title: 'Storico delle modifiche',
			empty: 'L’elenco è vuoto',
			table: {
				date: 'Data della modifica',
				field_name: 'Azione',
				old_value: 'Valore precedente',
				new_value: 'Nuovo valore',
				user: 'Modificato da',
			},
		},
	},

	pageShop: {
		title: 'Negozio',
		description:
			'Nel negozio puoi acquistare vari articoli per migliorare l’aspetto visivo della tua area personale.',

		tabs: {
			all: 'Tutti i prodotti',
			purchased: 'Acquistati',
		},

		item: {
			off_all: 'Nessuno',

			status: {
				AVAILABLE: 'Consigliato',
				DEPRECATED: 'Non disponibile',
				COMING_SOON: 'Prossimamente',
			},
			is_activated: 'Selezionato',
			set_active: 'Seleziona',
			unset_active: 'Disattiva',
			preview: 'Anteprima',
			is_free: 'Gratuito',
			buy: 'Acquista',
			bought: 'Acquistato',
			purchased: 'Acquistato',
		},
		empty: {
			all: 'Nessun miglioramento disponibile',
			purchased: 'Nessun miglioramento acquistato',
		},

		toast: {
			error: 'Si è verificato un errore',
			notEnoughMoney: 'Fondi insufficienti',
			itemBought: 'Miglioramento acquistato',
			itemActivated: 'Miglioramento attivato',
			itemDeactivated: 'Miglioramento disattivato',
		},
		confirmPurchase: {
			title: 'Conferma acquisto',
			message: 'Sei sicuro di voler acquistare questo articolo?',
			confirm: 'Sì, acquista',
			cancel: 'Annulla',
		},
	},

	demo: {
		title: 'Lezione di prova gratuita',
		tutorial: {
			title: 'Istruzioni',
			text:
				'Benvenuto alla lezione di prova online di aritmetica mentale Indigo Mental.\nIndigo Mental è la migliore scuola di aritmetica mentale al mondo. Grazie a tanti anni di esperienza e i successi di molti studenti nelle olimpiadi internazionali dimostrano che questo metodo è efficace, unico e funzionale. Molti genitori hanno già visto i risultati: i loro figli migliorano non solo in matematica, ma anche in altre materie, nella musica, nello sport e mostrano un grande sviluppo delle capacità intellettive.\nL’aritmetica mentale è un metodo giapponese di calcolo rapido a mente che sviluppa intensamente le capacità mentali e l’intelligenza del bambino. L’apprendimento avviene con l’uso dell’abaco giapponese. L’aritmetica mentale allena contemporaneamente l’emisfero sinistro e destro del cervello, migliorando memoria visiva, concentrazione, creatività e pensiero figurativo.\nCominciamo subito! Premi il pulsante “PLAY” nel video qui sotto, ascolta e ripeti.',
		},
	},

	disableStudent: {
		btn: 'Disattiva studente',
		list: 'Studenti senza data di disattivazione',
		modal: {
			title: 'Disattivazione dello studente',
			description: 'Stai per disattivare lo studente',
			fieldLabel: 'Seleziona il mese',
			btnSubmit: 'Disattiva',
			btnCancel: 'Annulla',
		},
	},
}
